var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.923 10.1c.151.152.151.397 0 .548l-1.278 1.275c-.151.151-.397.151-.548 0L12 13.806l-2.1 2.117c-.152.151-.397.151-.548 0l-1.275-1.278c-.151-.151-.151-.397 0-.548L10.194 12 8.077 9.9c-.151-.152-.151-.397 0-.548l1.278-1.278c.151-.151.397-.151.548 0L12 10.194l2.1-2.117c.152-.151.397-.151.548 0l1.278 1.278c.151.151.151.397 0 .548L13.806 12l2.117 2.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.923 14.1c.151.152.151.397 0 .548l-1.278 1.275c-.151.151-.397.151-.548 0L12 13.806l-2.1 2.117c-.152.151-.397.151-.548 0l-1.275-1.278c-.151-.151-.151-.397 0-.548L10.194 12 8.077 9.9c-.151-.152-.151-.397 0-.548l1.278-1.278c.151-.151.397-.151.548 0L12 10.194l2.1-2.117c.152-.151.397-.151.548 0l1.278 1.278c.151.151.151.397 0 .548L13.806 12l2.117 2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircle);
export default __webpack_public_path__ + "static/media/times-circle.80023375203fe8cb5c17f957e2ee20a0.svg";
export { ForwardRef as ReactComponent };